import React from "react";

const LinkedInIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.49084 3.03452C1.16302 2.6966 1 2.27831 1 1.78063C1 1.28294 1.1639 0.846257 1.49084 0.507366C1.81865 0.169444 2.24062 0 2.75762 0C3.27462 0 3.68004 0.169444 4.00698 0.507366C4.33479 0.845288 4.49781 1.27036 4.49781 1.78063C4.49781 2.2909 4.33392 2.6966 4.00698 3.03452C3.67916 3.37244 3.26329 3.54188 2.75762 3.54188C2.25196 3.54188 1.81865 3.37244 1.49084 3.03452ZM4.22232 4.97297V15.3333H1.27462V4.97297H4.22232Z"
      fill="white"
    />
    <path
      d="M14.0355 5.99687C14.678 6.77148 14.9989 7.83463 14.9989 9.18826V15.1508H12.1994V9.60848C12.1994 8.92586 12.0399 8.39524 11.7216 8.01762C11.4034 7.64 10.9745 7.45023 10.4374 7.45023C9.90036 7.45023 9.47139 7.63904 9.15317 8.01762C8.83495 8.39524 8.6754 8.92586 8.6754 9.60848V15.1508H5.85938V4.94437H8.6754V6.298C8.96049 5.84679 9.345 5.49048 9.828 5.22808C10.311 4.96568 10.8541 4.83496 11.4583 4.83496C12.5342 4.83496 13.3938 5.22226 14.0355 5.9959V5.99687Z"
      fill="white"
    />
  </svg>
);

export default LinkedInIcon;
